import { render, staticRenderFns } from "./ifp.vue?vue&type=template&id=4696fea3&"
import script from "./ifp.vue?vue&type=script&lang=js&"
export * from "./ifp.vue?vue&type=script&lang=js&"
import style0 from "./ifp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports